import Controller from '@ember/controller';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

/** @module */
class SignupBackgroundController extends Controller {
  @service api;
  @service('state-managers/application') applicationStateManager;
  @service store;
  @service('commands/user-commands') userCommandService;

  /**
   * @param {Object} v
   * @param {string} v.description
   * @param {string} v.personal_website
   * @param {Ember.A} v.equipment,
   * @param {Ember.A} v.tags
   * @param {Ember.A} v.languages
   * @param {boolean} v.conflict_reporting
   * @param {boolean} v.cr_hostile_env_training
   * @param {boolean} v.cr_first_aid_training
   * @param {Ember.A} v.cr_citizenships
   * @param {string} v.cr_full_name
   * @param {string} v.cr_relationship
   * @param {string} v.cr_phone
   * @param {string} v.cr_email
   */
  @action
  updateUser({
    description,
    equipment,
    tags,
    languages,
    personal_website: personalWebsite,
    conflict_reporting: conflictReporting,
    cr_hostile_env_training: crHostileEnvTraining,
    cr_first_aid_training: crFirstAidTraining,
    cr_citizenships: crCitizenships,
    cr_full_name: crFullName,
    cr_relationship: crRelationship,
    cr_phone: crPhone,
    cr_email: crEmail,
  }) {
    const {
      user,
      profile,
    } = this.model;

    return this._createTags(tags).then((tags) => {
      const userProps = { description };
      const userRelationships = { tags };

      const profileProps = { personalWebsite, conflictReporting };
      const profileRelationships = { equipment, languages };

      if (conflictReporting) {
        Object.assign(profileProps, {
          crHostileEnvTraining,
          crFirstAidTraining,
          crFullName,
          crRelationship,
          crPhone,
          crEmail,
          crCitizenships: crCitizenships.map(c => c.name).join(';') || null,
        });
      }

      const userSave = this.userCommandService.updateUser(user, userProps, userRelationships);
      const profileSave = this.userCommandService.updateUserProfile(user, profile, profileProps, profileRelationships);

      return Promise.all([userSave, profileSave]);
    }).then(() => {
      this.applicationStateManager.addToast('Settings updated');
    });
  }

  /**
   * @param {Ember.A<string>} tags
   * @returns {Promise<DS.Model[]>}
   */
  _createTags(tags) {
    if (tags.length === 0) {
      return Promise.resolve([]);
    }

    const { api, store } = this;

    const options = {
      jsonData: {
        names: tags,
      },
    };

    return api.post('tags/', options).then((response) => {
      store.pushPayload(response);
      return response.data.map(({ id }) => store.peekRecord('tag', id));
    });
  }
}

export default SignupBackgroundController;
